module.exports = __webpack_public_path__ + "img/worksheet-sidebar.dff12eb1.svg";